import { Component, OnInit } from '@angular/core';
import { LoadingControllerService } from '../../services/loading-controller/loading-controller.service';

@Component({
  selector: 'baf-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})
export class LoadingComponent {

  loadingVisible = false;
  loadingMessage = "Ładowanie ...";

  constructor(private loadingController: LoadingControllerService) {
    loadingController.activeLoadingStream.subscribe(visible => {
      this.loadingVisible = visible;
      this.loadingMessage = loadingController.loadingMessage;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/loading/loading.component.ts